var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal',{staticClass:"bg-transparent outline-none",attrs:{"name":"youTubeModal","id":"ytModal","width":_vm.width,"height":'auto',"scrollable":true}},[_c('div',{staticClass:"w-full h-full bg-transparent"},[_c('youtube',{ref:"youtube",attrs:{"fitParent":true,"video-id":_vm.videoId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }